import * as Scrivito from "scrivito";

export default function basicNewsQuery(siteId, currentHour, offset) {
  return Scrivito.Obj.onSite(siteId)
    .all()
    .and("_objClass", "equals", "NewsPage")
    .andNot("publishUntilDate", "isLessThan", currentHour)
    .offset(offset);
}
